import * as React from 'react'
import {importReg} from '../../dispatchers/appRegImportDispatcher'
import {connect} from 'react-redux'
import {IAppStore} from '../../interfaces/reducers'
import {IConnectValidationData, IConnectValidationSuccessData} from '../../interfaces/reducers/IRegImport'

interface OwnProps {
  connectValidationData: IConnectValidationData
}

interface ParentProps {}

interface DispatchProps {
  importReg: typeof importReg
}

type Props = DispatchProps & ParentProps & OwnProps

const RegImportConnectValidationsClass = (props: Props) => {
  const getSuccessData = (successData: IConnectValidationSuccessData) => {
    return (
      <div className="import-params-success">
        <div>Успешно създадени връзки</div>
        <br></br>
        <div>{`Брой нови квартали: ${successData.NewQuarters}`}</div>
        <div>{`Брой обновени квартали: ${successData.UpdatedQuarters}`}</div>
        <br></br>
        <div>{`Брой нови парцели: ${successData.NewParcels}`}</div>
        <div>{`Брой обновени парцели: ${successData.UpdatedParcels}`}</div>
        <br></br>
        <div>{`Брой нови точки: ${successData.NewPoints}`}</div>
        <div>{`Брой обновени точки: ${successData.UpdatedPoints}`}</div>
        <br></br>
        <div>{`Брой нови осови линии: ${successData.NewRegOsLines}`}</div>
        <div>{`Брой нови линии: ${successData.NewRegLines}`}</div>
        <br></br>
        <div style={{wordBreak: 'break-all'}}>{`Осови точки с повтарящи се номера: ${
          successData.DublicatePointNumbers || 0
        }`}</div>
        <br></br>
        {successData.NextPlans.length > 0 && successData.PreviousPlans.length > 0 ? (
          <div className="import-params-warnings">
            <div>
              Анализът е извършен спрямо предишните планове: {successData.PreviousPlans.join(', ')} и не отразява
              крайния резултат след прилагането на последващите изменения: {successData.NextPlans.join(', ')}
            </div>
          </div>
        ) : null}
        <a href={successData.SuccessDxf} target="_blank" rel="noreferrer">
          DXF файл с промените
        </a>
        <br></br>

        <br></br>
      </div>
    )
  }
  const getValidationStatusUI = () => {
    if (props.connectValidationData.loading) {
      if (props.connectValidationData.successData) {
        return getSuccessData(props.connectValidationData.successData)
      }
      return <div className="import-loading">В процес на създаване на връзки...</div>
    } else {
      if (
        props.connectValidationData.errors &&
        props.connectValidationData.errors.messages &&
        props.connectValidationData.errors.messages.length > 0
      ) {
        const errors: JSX.Element[] = []
        props.connectValidationData.errors.messages.forEach((e, i) => {
          errors.push(<div key={i}>{e}</div>)
        })
        return (
          <div className="import-params-errors">
            <div>Грешки при създаване на връзки:</div>
            {errors}
            {props.connectValidationData.errors.dxf ? (
              <a href={props.connectValidationData.errors.dxf} target="_blank" rel="noreferrer">
                DXF файл с грешни полигони
              </a>
            ) : null}
          </div>
        )
      } else if (props.connectValidationData.successData) {
        return getSuccessData(props.connectValidationData.successData)
      }
    }
  }
  if (!props.connectValidationData.exists) {
    return <div></div>
  }
  return <div style={{padding: '10px', boxSizing: 'border-box'} as React.CSSProperties}>{getValidationStatusUI()}</div>
}

const mapStoreToProps = (store: IAppStore) => ({
  connectValidationData: store.regImport.connectValidationData
})

export const RegImportConnectValidations = connect<OwnProps, DispatchProps, ParentProps>(mapStoreToProps, {importReg})(
  RegImportConnectValidationsClass
)
